export default __webpack_public_path__ + "static/media/eagle_opt.e7b7f2bb.gif";